var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.LOGISTICS_COMPANY_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.spuName"),
                          prop: "name",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("goodsPage.spuName"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "name", $$v)
                            },
                            expression: "queryParams.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "businessLogisticsCompany.common.status"
                          ),
                          prop: "enableFlag",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_ENABLED_TRUE,
                            placeholder: _vm.$t(
                              "businessLogisticsCompany.common.status"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.enableFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "enableFlag", $$v)
                            },
                            expression: "queryParams.enableFlag",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessLogisticsCompanyList_Add",
                            arg: "BusinessLogisticsCompanyList_Add",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("businessLogisticsCompany.common.add"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "enableFlag"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row[col.prop]
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_TRUE.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessLogisticsCompanyList_Edit",
                                            arg: "BusinessLogisticsCompanyList_Edit",
                                          },
                                        ],
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    !scope.row.enableFlag
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:BusinessLogisticsCompanyList_Status",
                                                arg: "BusinessLogisticsCompanyList_Status",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onStatus(
                                                  true,
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("enableText")))]
                                        )
                                      : _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:BusinessLogisticsCompanyList_Status",
                                                arg: "BusinessLogisticsCompanyList_Status",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onStatus(
                                                  false,
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("disableText"))
                                            ),
                                          ]
                                        ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessLogisticsCompanyList_Delete",
                                            arg: "BusinessLogisticsCompanyList_Delete",
                                          },
                                        ],
                                        staticClass: "delete-btn",
                                        attrs: {
                                          disabled: scope.row.status == 1,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", {
        ref: "DataForm",
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }